<template>
  <div class="station-instructions" v-if="instructions || scenario">
    <div class="instructions-header">
      <h3>Station Instructions</h3>
    </div>
    
    <div class="instructions-content">
      <div v-if="scenario" class="scenario-section">
        <h4>Scenario</h4>
        <p class="scenario-text">{{ scenario }}</p>
      </div>
      
      <div v-if="instructions" class="tasks-section">
        <h4>Tasks to Assess</h4>
        <ul class="tasks-list">
          <li 
            v-for="(task, index) in parsedInstructions" 
            :key="index"
            class="task-item"
          >
            {{ task }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    instructions: String,
    scenario: String
  },
  
  computed: {
    parsedInstructions() {
      if (!this.instructions) return [];
      // Split instructions by newlines or bullets
      return this.instructions.split('\n').filter(line => line.trim());
    }
  }
}
</script>

<style scoped>
.station-instructions {
  background: white;
  margin: 0 20px 20px 20px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  overflow: hidden;
}

.instructions-header {
  background: #007bff;
  color: white;
  padding: 15px 20px;
}

.instructions-header h3 {
  margin: 0;
  font-size: 1.1em;
  font-weight: 600;
}

.instructions-content {
  padding: 20px;
}

.scenario-section,
.tasks-section {
  margin-bottom: 20px;
}

.scenario-section:last-child,
.tasks-section:last-child {
  margin-bottom: 0;
}

.scenario-section h4,
.tasks-section h4 {
  color: #2c3e50;
  margin: 0 0 10px 0;
  font-size: 1em;
  font-weight: 600;
}

.scenario-text {
  line-height: 1.6;
  color: #495057;
  margin: 0;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 3px solid #007bff;
}

.tasks-list {
  margin: 0;
  padding-left: 20px;
}

.task-item {
  line-height: 1.6;
  color: #495057;
  margin-bottom: 8px;
  padding: 5px 0;
}

.task-item:last-child {
  margin-bottom: 0;
}

.task-item::marker {
  color: #007bff;
}
</style>